import { Directive, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { TreeWrapperNode } from '../models/tree-wrapper-node.model';

/**
 * Directiva placeholder para drop functionality
 * Mantiene compatibilidad con el template original pero no implementa funcionalidad completa
 */
@Directive({
    selector: '[treeDrop]',
    standalone: false
})
export class TreeDropDirective {
  @Input() treeAllowDrop: TreeWrapperNode;
  @Output() treeDrop = new EventEmitter<any>();

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent): void {
    event.preventDefault();
    // Implementación futura para drop
    this.treeDrop.emit(event);
  }

  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }
}

